::ng-deep particle-activity-filter-transactions-selector{height:100%}::ng-deep particle-activity-filter-transactions-selector particle-tree-selector .tree-selector-height{height:100%!important}
/*# sourceMappingURL=activity-filter-transactions-selector.component-TQPKBOGX.css.map */
